import EventBanner from "../../../public/banners/vtuber_only_banner.jpg";
import SocietyListImage from "../../../public/events/vtuber-only/vtuber_only_list.jpg";

export default {
  date: "28-10-2022",
  description:
    "受疫情的影響歷經兩次延期，今次終於要在11月5日舉辦《VTUBER-ONLY》虛擬實況主同人誌販售交流會了﹗",
  images: { SocietyListImage },
  mainImage: EventBanner,
  title:
    "11月5日《VTUBER-ONLY》虛擬實況主同人誌販售交流會將於國立臺灣師範大學舉辦",
  mdContent: `
受疫情的影響歷經兩次延期，今次終於要在11月5日舉辦《VTUBER-ONLY》虛擬實況主同人誌販售交流會了﹗（極力鼓掌﹗）

## 活動詳情如下：

- 活動日期： 2022年11月05日 (星期六)
- 活動時間： 10:30 - 16:00
- 一般入場費用： 200元 (現場售票)
- 活動地點： 國立臺灣師範大學中正堂 (公館校區)

雖然終於能夠順利舉辦活動，但考慮到近期疫情又有回升的趨勢，將視活動當日的情況進行入場人數管制、減少舞台活動的項目以保持參與者之間的防疫距離。
另外，因之前角色扮演者申請過於踴躍，考量現場人數負荷與防疫感控要求，本次暫不開放新的角色扮演申請，這部分還請各位見諒。

---

以下附上參與的社團名單：

![VTUBER-ONLY 參與社團名單](SocietyListImage)

---

各種活動消息會陸續於活動官網、FB粉專、噗浪同步更新，歡迎各位將粉專加入關注以掌握最新資訊。
  `,
  mdInfo: `
# 活動資訊

**VTUBER-ONLY 官網：<https://vtuberonly2021.weebly.com>**
**Facebook：<https://www.facebook.com/VtuberOnly>**
**噗浪：<https://www.plurk.com/VtuberOnly>**
  `,
};
